import type { Channel, ChannelStats, ConversationStats } from 'types/stats';

export type AggregatedTotals = {
  total: {
    last24h: number;
    last7Days: number;
    last30Days: number;
    yearToDate: number;
  };
  byChannel: Record<Channel, ChannelStats | undefined>;
};

export function aggregateConversationStats(stats: ConversationStats | null): AggregatedTotals {
  if (!stats || stats.length === 0) {
    return {
      total: {
        last24h: 0,
        last7Days: 0,
        last30Days: 0,
        yearToDate: 0,
      },
      byChannel: {
        website: undefined,
      },
    };
  }

  const byChannel = stats.reduce<Record<Channel, ChannelStats | undefined>>(
    (acc, curr) => {
      acc[curr.channel] = curr;
      return acc;
    },
    {
      website: undefined,
    },
  );

  const total = stats.reduce(
    (acc, curr) => {
      acc.last24h += curr.last24h;
      acc.last7Days += curr.last7Days;
      acc.last30Days += curr.last30Days;
      acc.yearToDate += curr.yearToDate;
      return acc;
    },
    {
      last24h: 0,
      last7Days: 0,
      last30Days: 0,
      yearToDate: 0,
    },
  );

  return { total, byChannel };
}
